<template>
    <a class="systemBox h-100 p-2 d-flex flex-column justify-content-between align-items-center background-white" @click="selectCard" :class="getBGColor">
        <div class="align-self-end" @click.stop @click="openInfoBox">
            <i class="fa-light fa-circle-info fa-lg"></i>
        </div>
      
        <div class="" v-if="system.image">
            <img :src="getSystemPicture" />
        </div>
        <div class="" v-if="system.icon">
            <i :class="system.icon" class="vertical-align-middle fa-8x"></i>
        </div>
        <div class="text-primary">
            {{ system.name }}
        </div>
    </a>
</template>

<script>
import ModalMessageHandler from '@/assets/js/ModalMessageHandler';
import { mapGetters } from 'vuex';

export default {
    name: "SystemCard",
    emits: ['selectCard'],
    data() {
        return {}
    },
    methods: {
        selectCard() {
            this.$emit('selectCard', this.system);
        },
        openInfoBox(event) {
            let handler = new ModalMessageHandler(this.$store, event);
            handler.newMessage(
                'daliSolution.'+ this.system.systemType+'.name',
                'daliSolution.'+ this.system.systemType+'.infoText'
            )
        },
    },
    computed: {
        getSystemPicture() {
            return this.imagePath+this.system.image;
            //var images = require.context('../../assets/images/')
/*             return images(this.system.image) */
        },
        getBGColor() {
            if(this.system.active) {
                return "active"
            }
            return ""
        },
        ...mapGetters({
            imagePath: 'app/getImagePath'
        })
    },
    props: {
        system: Object
    }
}
</script>

<style lang="scss" scoped>

</style>